import { useState, useEffect } from "react";
import { CgMenu } from "react-icons/cg";

import DesktopNavigation from "./DesktopNavigation";
import MobileNavigation from "./MobileNavigation";

import classes from "./css/MainNavigation.module.css";

const MainNavigation = () => {
  const [scrollDirection, setScrollDirection] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const onOpenHandler = () => {
    setShowMenu(true);
    document.body.style.overflow = "hidden";
  };

  const onCloseHandler = () => {
    setShowMenu(false);
    document.body.style.overflow = "unset";
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 5 || scrollY - lastScrollY < -5)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection);
    return () => {
      window.removeEventListener("scroll", updateScrollDirection);
    };
  }, [scrollDirection]);

  return (
    <header
      className={classes.header}
      style={{ top: scrollDirection === "down" ? "-6rem" : "0" }}
    >
      <DesktopNavigation />

      {showMenu ? (
        <MobileNavigation onClick={onCloseHandler} />
      ) : (
        <>
          <CgMenu className={classes.menuClose} onClick={onOpenHandler} />
        </>
      )}
    </header>
  );
};

export default MainNavigation;
